// src/pages/Home.js
import React from 'react';
import Perfil from '../PerfilComponents/Perfil';
function Home() {
  return (
    <div>
      <Perfil/>
    </div>
  );
}

export default Home;